import { FC } from "react";
import styled from "styled-components";

import { formatEuro } from "../common/constants";

const StyledMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
`;

const StyledMetric = styled.div`
  padding: 1rem;
  background: #f5f5f5;
  border-radius: 6px;
  text-align: center;
`;

const StyledMetricValue = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: #2196f3;
`;

const StyledMetricLabel = styled.div`
  font-size: 0.9rem;
  color: #666;
  margin-top: 0.5rem;
`;

type MetricData = {
  totalRevenueEuro: number;
  uniqueBuyersCount: number;
  avgSpentPerBuyerEuro: number;
  totalPurchases: number;
  avatarPurchases: number;
  badgePurchases: number;
};

type SpendingOverviewProps = {
  data: MetricData;
};

export const SpendingOverview: FC<SpendingOverviewProps> = ({ data }) => {
  return (
    <StyledMetrics>
      <StyledMetric>
        <StyledMetricValue>
          {formatEuro(data.totalRevenueEuro)}
        </StyledMetricValue>
        <StyledMetricLabel>Revenus totaux</StyledMetricLabel>
      </StyledMetric>
      <StyledMetric>
        <StyledMetricValue>{data.uniqueBuyersCount}</StyledMetricValue>
        <StyledMetricLabel>Acheteurs uniques</StyledMetricLabel>
      </StyledMetric>
      <StyledMetric>
        <StyledMetricValue>
          {formatEuro(data.avgSpentPerBuyerEuro)}
        </StyledMetricValue>
        <StyledMetricLabel>Moyenne par acheteur</StyledMetricLabel>
      </StyledMetric>
      <StyledMetric>
        <StyledMetricValue>{data.totalPurchases}</StyledMetricValue>
        <StyledMetricLabel>Total achats</StyledMetricLabel>
      </StyledMetric>
      <StyledMetric>
        <StyledMetricValue>{data.avatarPurchases}</StyledMetricValue>
        <StyledMetricLabel>Achats d'avatars</StyledMetricLabel>
      </StyledMetric>
      <StyledMetric>
        <StyledMetricValue>{data.badgePurchases}</StyledMetricValue>
        <StyledMetricLabel>Achats de badges</StyledMetricLabel>
      </StyledMetric>
    </StyledMetrics>
  );
};
